import { useMutation, useQueryClient } from "@tanstack/react-query";
import {
  QueryKeys,
  useAppLocation,
  useAppState,
  useAppTranslation,
} from "../../../common";
import { ErrorModal, Modal } from "../../../components";
import { deleteFactAction } from "../../../actions";

type FactDeleteModalProps = {
  handleDeleteModalVisible: () => void;
};

export function FactDeleteModal(props: FactDeleteModalProps) {
  const { t } = useAppTranslation();
  const location = useAppLocation();

  const queryClient = useQueryClient();
  const [state, setState] = useAppState({
    errorModalVisible: false,
  });

  const handleModalVisibility = () => {
    setState((prevState) => ({
      ...prevState,
      errorModalVisible: !prevState.errorModalVisible,
    }));
  };

  const deleteFact = useMutation({
    mutationKey: [QueryKeys.deleteFactQuery],
    mutationFn: deleteFactAction,
    onSuccess() {
      props.handleDeleteModalVisible();
      queryClient.invalidateQueries({ queryKey: [QueryKeys.factsQuery] });
    },
    onError() {
      handleModalVisibility();
    },
  });

  const handleDeleteFact = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    deleteFact.mutate({ id: location.state?.id });
  };

  return (
    <div>
      <section>
        <Modal
          onClose={props.handleDeleteModalVisible}
          title={t("fact-page-delete-modal-title")}
          footer
          submitText={t("fact-page-delete-submit-button-title")}
          cancelText={t("fact-page-delete-cancel-button-title")}
          handleSubmit={handleDeleteFact}
          loading={deleteFact.isPending}
        >
          <span>{t("fact-page-delete-fact-question-label")}</span>
        </Modal>
      </section>
      <section>
        {state.errorModalVisible && (
          <ErrorModal
            error={deleteFact.error}
            onClose={handleModalVisibility}
            title={t("fact-page-delete-fact-error-modal-title")}
          />
        )}
      </section>
    </div>
  );
}
